import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  ticket: {
    width: '80mm',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '10mm 2mm',
  },
  ticketItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '1mm 0'
  },
  ticketItemBorder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    padding: '1mm 0'
  },
  tableCell: {
    padding: 0,
  },
  tableHeader: {
    padding: '0 1mm'
  }
});